export default {
  toasts: {
    failed_to_delete_website: 'Verkkosivuston poistaminen epäonnistui',
    website_deleted: 'Verkkosivusto poistettiin',
  },
  delete_model: {
    title: 'Haluatko varmasti poistaa verkkosivuston?',
    confirm: 'Poista',
    cancel: 'Peruuta',
  },
  buttons: {
    open_editor: 'Avaa editori',
    transfer_website: 'Siirrä verkkosivusto',
    delete_site: 'Poista',
  },
};
